import { useState, useEffect, useNavigate } from '../../../libraries/index.js';
import {
  getServices,
  deleteService,
  updateServices,
  handleSuccessResponse,
  handleErrorResponse,
  getAllCategory,
  getAllSubCategory
} from '../../../services/index.js';
import { useDebouncedValue } from '../../../jsonData/debouncingFunction.js';
import { BusinessRoutes } from '../../../routes/index.js';
import { GetOrganizationStatus } from '../index';
import { returnObj } from './dataObj.js';
const useServicesData = () => {
  const navigate = useNavigate();
  const { isOrganizationStatus } = GetOrganizationStatus();
  const [serviceData, setServiceData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [spinner, setSpinner] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategory] = useState([]);
  const [searchServices, setSearchServices] = useState('');
  const [showFilterRow, setShowFilterRow] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  const [filterValue, setFilterValue] = useState({
    serviceId: '',
    duration: '',
    price: '',
    specialPrice: '',
    status: '',
    category: '',
    subCategory: '',
  });
  const [isFlaceMessage, setIsFlashMessage] = useState('');
  const debouncedSearchTerm = useDebouncedValue(filterValue, 500);
  const [showEmptyPage, setShowEmptyPage] = useState(false);
  const [isComplte, setIsComplte] = useState(false);

  useEffect(() => {
    fetchData();
  }, [isOrganizationStatus, debouncedSearchTerm]);

  const fetchData = async () => {
    setSpinner(true);
    try {
      if (filterValue.category) {
        const subCategory = await getAllSubCategory(filterValue.category);
        setSubCategory(subCategory.data);
      }
      const params = paramObject(currentPage, itemsPerPage);
      const serviceResponse = await getServices(params);
      if (serviceResponse?.data?.services) {
        const categories = await getAllCategory();
        setCategories(categories.data);
        setServiceData(serviceResponse?.data?.services);
        if (
          serviceResponse?.data?.services?.length < 0 ||
          serviceResponse?.data?.status_code === 204
        ) {
          setShowEmptyPage(true);
        } else {
          setShowEmptyPage(false);
        }
        setTotalPage(serviceResponse?.data?.total_pages * itemsPerPage);
      } else {
        setServiceData([]);
        setTotalPage(0);
        const allValuesNull = isObjectEmpty(params);
        if (allValuesNull) {
          setShowEmptyPage('emptyServices');
        } else {
          setShowEmptyPage('emptyServicesFilter');
        }
      }
    } catch (error) {
      setShowEmptyPage(true);
      if (error?.response?.data?.status_code === 404) {
        handleErrorResponse(error);
      }
      if (error?.response?.status)
        setIsFlashMessage(error?.response?.data?.error);
      else handleErrorResponse(error);
    } finally {
      setSpinner(false);
    }
  };

  const isObjectEmpty = (params) => {
    const obj = Object.fromEntries(params.entries());
    for (let key in obj) {
      if (
        key !== 'page_number' &&
        key !== 'per_page' &&
        (obj[key] === null || obj[key] === '')
      ) {
        continue;
      }
      if (key !== 'page_number' && key !== 'per_page') {
        return false;
      }
    }
    return true;
  };

  const handlefilterInputChange = (name, value) => {
    setFilterValue({ ...filterValue, [name]: value });
  };

  const handleShow = () => setShowModal(true);

  const handleClose = () => {
    setIsComplte(false);
    setShowModal(false);
  };

  const deleteServices = async (id) => {
    setShowModal(false);
    setIsComplte(false);
    setSpinner(true);
    try {
      const response = await deleteService(id);
      if (response?.data?.status_code === 422)
        handleSuccessResponse(response, response?.data?.message);
      else {
        const updatedServiceData = serviceData?.filter(
          (item) => item?.service?.id !== id,
        );
        setServiceData(updatedServiceData);
        handleSuccessResponse(response, response?.data?.message);
      }
    } catch (error) {
      handleErrorResponse(error);
    } finally {
      setSpinner(false);
    }
  };

  const paramObject = (page, pageSize) => {
    return new URLSearchParams({
      page_number: page,
      per_page: pageSize,
      service_name_en: filterValue?.serviceId,
      duration: filterValue?.duration
        ? parseInt(filterValue?.duration, 10)
        : '',
      price: filterValue?.price ? parseInt(filterValue?.price, 10) : '',
      special_price: filterValue?.specialPrice
        ? parseInt(filterValue?.specialPrice, 10)
        : '',
      category_id: filterValue?.category,
      sub_category_id: filterValue?.subCategory,
      is_enabled: filterValue?.status,
      search: searchServices,
    });
  };

  const editService = (serviceObject) => {
    navigate(`${BusinessRoutes.bussiness}${BusinessRoutes.buisinesseditService}`, { state: serviceObject });
  };

  const showBookingsRecords = (serviceObject) => {
    localStorage.setItem('isSection', 'isBusinessBooking');
    navigate(`${BusinessRoutes.bussiness}${BusinessRoutes.bussinessbookings}`, { state: serviceObject });
  };

  const addNewService = () => {
    navigate(`${BusinessRoutes.bussiness}${BusinessRoutes.addService}`);
  };

  const returnFormData = (values, slotArray) => {
    const data = {
      category_id: values?.category_id,
      sub_category_id: values?.sub_category_id,
      duration: values?.duration,
      service_name_en: values?.service_name_en,
      service_name_thai: values?.service_name_thai,
      ps_start_date: values?.ps_start_date,
      ps_end_date: values?.ps_end_date,
      price: values?.price,
      special_price: values?.special_price,
      description_en: values?.description_en,
      description_thai: values?.description_thai,
      cancel_day: values?.cancel_day,
      reschedule_day: values?.reschedule_day,
      special_term_en: values?.special_term_en,
      special_term_thai: values?.special_term_thai,
      is_featured_service: values?.is_featured_service,
      is_voucher: values?.is_voucher,
      is_installment_enabled: values?.is_installment_enabled,
      is_enabled: values?.is_enabled,
    };

    const formData = new FormData();

    for (let key in data) {
      if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
        if (key === 'image' && data[key] instanceof File) {
          formData.append(key, data[key]);
        } else if (key !== 'image') {
          formData.append(key, data[key]);
        }
      }
    }

    if (Array.isArray(slotArray) && slotArray.length) {
      formData.append("discount_slot[slots]", JSON.stringify(slotArray));
    }

    return formData;
  };

  const activteDeactivateFun = async (serviceObj) => {
    serviceObj.service.is_enabled = !serviceObj.service.is_enabled;
    serviceObj.service.category_id = serviceObj.service.category.id;
    serviceObj.service.sub_category_id = serviceObj.service.sub_category.id;
    delete serviceObj.service.category;
    delete serviceObj.service.sub_category;
    try {
      const formData = returnFormData(
        serviceObj.service,
        serviceObj.service?.discount_slot?.slots.length > 0 ? serviceObj.service?.discount_slot?.slots : null,
      );

      formData.id = serviceObj?.service?.id;
      const response = await updateServices(formData);
      const updatedServiceData = serviceData?.map((item) =>
        item.service.id === response.data.service.id ? response.data : item,
      );
      setServiceData(updatedServiceData);
    } catch (error) {
      console.log('ERROR :-',error)
    }
  };

  const handlePaginationChange = async (page, pageSize) => {
    setSpinner(true);
    const queryParams = paramObject(page, pageSize);
    try {
      const serviceResponse = await getServices(queryParams);
      setServiceData(serviceResponse.data.services);
      setTotalPage(serviceResponse.data.total_pages * 15);
      setCurrentPage(page);
      setItemsPerPage(pageSize);
    } catch (err) {
      handleErrorResponse(err);
    } finally {
      setSpinner(false);
    }
  };

  const toggleFilterRow = () => {
    setShowFilterRow(!showFilterRow);
  };

  const clearFilterfunction = async () => {
    setCurrentPage(1);
    setFilterValue({
      serviceId: '',
      duration: '',
      price: '',
      specialPrice: '',
      status: '',
      category: '',
      subCategory: '',
    });
  };

  const filterDataFromSearchHere = async () => {
    setFilterValue({
      serviceId: '',
      duration: '',
      price: '',
      specialPrice: '',
      status: '',
      category: '',
      subCategory: '',
    });
  };

  return {
    filterValue,
    handlefilterInputChange,
    totalPage,
    toggleFilterRow,
    showFilterRow,
    filterDataFromSearchHere,
    clearFilterfunction,
    spinner,
    serviceData,
    showModal,
    handleShow,
    handleClose,
    editService,
    addNewService,
    deleteServices,
    setDeleteItemId,
    deleteItemId,
    activteDeactivateFun,
    handlePaginationChange,
    currentPage,
    itemsPerPage,
    categories,
    subCategories,
    setSearchServices,
    showBookingsRecords,
    isFlaceMessage,
    isOrganizationStatus,
    showEmptyPage,
    isComplte,
    setIsComplte,
  };
};

export default useServicesData;
